import { FileError, FileRejection, useDropzone } from "react-dropzone";
import React, { useEffect, useState } from "react";
//import { uploadImageToS3, getPresignedUrl } from "../../features/actions/s3";
//import { getServiceProviderData, updateServiceProvider } from "../../services/ServiceProvidersService";
//import toast, { Toaster } from "react-hot-toast";
import {API_URL} from "../../utils/api";
import axios  from "axios";
import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";

const MAX_FILE_SIZE_MB = 100;
//const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
const MAX_FILE_SIZE_BYTES = 100 * 1024;
const MAX_IMAGE_COUNT = 1;

const Dropzone = (props) => {
    const [uploading, setUploading] = useState(false);
    let activeuser =localStorage.getItem('activeUser');
    //activeuser =  JSON.parse(activeuser);
    let  basicUserInfo2 = (activeuser) ? JSON.parse(activeuser) : [];
    const [currentUserRole, setCurrentUserRole] = useState(basicUserInfo2); // useContext(userRoleContext);
    let handleClose = props.handleClose;

   const navigate = useNavigate();


    const typeValidator = (file) => {
        if (file.size > MAX_FILE_SIZE_BYTES) {
            return {
                code: "size-too-large",
                message: `Image file is larger than ${MAX_FILE_SIZE_MB}KB.`,
            };
        }
        return null;
    };
 
    useEffect(() => {
        async function loadData() {
            let userinfo =basicUserInfo2; // await getServiceProviderData(basicUserInfo2.id);
            if (userinfo != null) {
                setCurrentUserRole(userinfo[0]);
            } else {
                alert('Got error while fetching data from api');
            }
        }
        loadData();
    }, []);


    const onDrop = async (
        acceptedFiles,
        rejectedFiles
    ) => {
        if (rejectedFiles.length > 0) {
            alert(
                `You're trying to upload a file larger than ${MAX_FILE_SIZE_MB}KB. Please try again.`
            );
            return;
        }

        setUploading(true);

        try {
            let formData = new FormData();
            await acceptedFiles.forEach((file) => formData.append("image", file));
            console.log(acceptedFiles[0]['name']);
            let filename = acceptedFiles[0]['name'];
            const imgprefix = filename.split(".");
            let uniqname = `${Date.now()}`;
            console.log(uniqname);
            uniqname = uniqname + "." + imgprefix[imgprefix.length - 1];
           

            formData = {...formData, ...{image:acceptedFiles[0] }};
            
              console.log(formData);
              axios.post(process.env.REACT_APP_API_BASE_URL+"UpdateProfilePic/"+basicUserInfo2.id, { ...formData }, {
                headers: {
                  "content-type": "multipart/form-data"
                },
                
              })
                .then((res) => {
                    console.log(res.data);
                    // return false;
                  if(res.data.status === true){
                      toast.success('profile pic updatd sucessfully!!');
                      basicUserInfo2.image = res.data.image;
                      localStorage.setItem('activeUser', JSON.stringify(basicUserInfo2));
   


                      setTimeout(() => {
                        navigate('/'+basicUserInfo2.user_type+'/profile');
                      }, 2000);
                  }
                  else{
                      toast.success("something went wrong...")
                  }
                })
                .catch(err => {
                  console.error(err);
                  toast.error(err);
                });
          


/*
            let resp = await uploadImageToS3(formData, {
                bucket: process.env.REACT_APP_API_NEXT_PUBLIC_BUCKET!,
                key: uniqname,
            });
            console.log('s3 resp:', resp);
            // alert("Files uploaded successfully!");
            let signedurl = await getPresignedUrl(uniqname);
            localStorage.setItem("signedurl", signedurl);
            console.log('signedurl:', signedurl);
            basicUserInfo2 = { ...basicUserInfo2, ...{ 'photo': uniqname } };
            localStorage.setItem("userProfile", JSON.stringify(basicUserInfo2));
            // console.log('basicUserInfo2:', basicUserInfo2);

            let regarray = {
                name: currentUserRole.name,
                email: currentUserRole.email,
                password: currentUserRole.password,
                mobile: currentUserRole.mobile,
                city: currentUserRole.city,
                state: currentUserRole.state,
                photo: uniqname,
                user_type: currentUserRole.user_type,
                address: currentUserRole.address,
                pincode: currentUserRole.pincode,
                service_type: 0,
                apassword: '',
                confirm_password: '',
                source: currentUserRole.source
            };


            let dt: any = await updateServiceProvider(currentUserRole.id, regarray);
            handleClose();
            if (dt) {
                alert('Profile pic uploaded successfully.');

            }*/

        } catch (error) {
            console.error("Error uploading image to S3:", error);
            alert("You are trying to upload larger than 500kb, Failed to upload image to S3. Please try again.");
        } finally {
            setUploading(false);
        }
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        validator: typeValidator,
        accept: {
            "image/jpeg": [],
            "image/png": [],
            "image/webp": [],
            "image/jpg": [],
        },
        maxSize: MAX_FILE_SIZE_BYTES,
        maxFiles: MAX_IMAGE_COUNT,
    });

    return (
        <div className="draganddrop">
            <ToastContainer></ToastContainer>
                   

            <div
                {...getRootProps()}
                className="mt-3 border-2 border-dashed border-slate-200 rounded-lg hover:bg-slate-100/50 cursor-pointer duration-200 p-8 text-center"
                style={{ border: "2px dotted #000", height: "200px" }}>
                <input {...getInputProps()} />
                {isDragActive ? (
                    <p>Drop the files here ...</p>
                ) : (
                    <p className="text-slate-400 mt-5">
                        {`Drag and drop some files here, or click to select files (up to ${MAX_IMAGE_COUNT} images, max ${MAX_FILE_SIZE_MB}KB each)`}
                    </p>
                )}
            </div>

            {uploading ? <p>Uploading...</p>:""}
 
        </div>
    );
};

export default Dropzone;